/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { useContentZone } from "cms/components/hooks/use-content-zone";
import { setLastComponentAdded } from "data/store/reducers/composer";

const ComponentList = (props) => {

    const {
        activeFieldName,
        componentPosition,
        components,
        dialogFieldName,
        handleCloseModal,
        isDisabled
    } = props;
    const maxComponentNameChars = 15;

    const { handleSelectComponentType } = useContentZone();
    const dispatch = useDispatch();

    const getFieldName = () => {
        return dialogFieldName || activeFieldName;
    };

    const handleSelectComponent = (event) => {
        const selectedComponentType = event.currentTarget.value;
        const selectedComponent = handleSelectComponentType(getFieldName(), selectedComponentType, componentPosition);
        dispatch(setLastComponentAdded(selectedComponent.guid));
        if (handleCloseModal) {
            handleCloseModal();
        }
    };

    const getTruncatedComponentName = (componentName) => {
        return componentName.length > maxComponentNameChars
            ? componentName.slice(0, maxComponentNameChars).trim() + "..."
            : componentName;
    };

    return (
        <div className="component-list-scroll">
            <div className='component-list-container'>
                {components.map((componentType, index) => {
                    const componentName = componentType?.label;
                    const truncatedComponentName = getTruncatedComponentName(componentName);
                    const isTruncated = componentName.length > maxComponentNameChars;

                    return (
                        <Tooltip
                            classes={{ tooltip: "component-name tooltip" }}
                            disableHoverListener={!isTruncated}
                            key={index}
                            placement='top'
                            title={isTruncated ? componentName : ""}
                        >
                            <div key={componentType.type}>
                                <Button
                                    disabled={isDisabled}
                                    onClick={handleSelectComponent}
                                    startIcon={<img src={componentType.icon} alt='icon' />}
                                    value={componentType.type || ""}
                                >
                                    <span className='component-type-text'>{truncatedComponentName}</span>
                                </Button>
                            </div>
                        </Tooltip>
                    );
                })}
            </div>
        </div>
    );
};

export { ComponentList };
